import { useEffect, useRef } from 'react'
import useSetParamsToRouter from 'live/lib/hooks/useSetParamsToRouter'
import { getHashParametersFiltered } from './utils'

/**
 * This custom hook add a listener to hashchanges, and passes a function that examine if the hash has run-parameters on it,
 * if it doesnt, the hook will update the hash with:
 *
 * hashValues - values on the hash that were not received through context
 * @param contextParams.current - dashboard parameters received through context
 * @param run-parameters values.
 *
 * This is important to add run-parameters to a dashboard's url.
 */

export function useGrantParamsOnURL(contextParamsRef, paramsRef) {
    const urlParameterListenerTriggered = useRef(false)
    const setParamsToRouter = useSetParamsToRouter(true)

    const checkHash = () => {
        let hashValues = getHashParametersFiltered(window.location.hash, contextParamsRef.current)

        if (
            (paramsRef.current?.length !== 0 && hashValues === undefined) ||
            (hashValues !== undefined && hashValues['run-parameters'] === undefined)
        )
            setParamsToRouter({
                ...contextParamsRef.current,
                ...hashValues,
                'run-parameters': encodeURIComponent(
                    encodeURIComponent(JSON.stringify(paramsRef.current.map(({ priority, ...attrs }) => attrs)))
                )
            })
    }

    useEffect(() => {
        if (paramsRef.current?.length !== 0 && !urlParameterListenerTriggered.current) {
            window.addEventListener('hashchange', checkHash)
            urlParameterListenerTriggered.current = true
            return () => window.removeEventListener('hashchange', checkHash)
        }
    }, [JSON.stringify(paramsRef.current)])
}
